import { render, staticRenderFns } from "./ShoppingListProductCard.vue?vue&type=template&id=f0f7d696&"
import script from "./ShoppingListProductCard.vue?vue&type=script&lang=js&"
export * from "./ShoppingListProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,BookOpen: require('/vercel/path0/components/icons/BookOpen.vue').default,ProductAuthors: require('/vercel/path0/components/product/ProductAuthors.vue').default,CanAddToCart: require('/vercel/path0/components/shop/CanAddToCart.vue').default})
